import _find from 'lodash/find';
import _flatMap from 'lodash/flatMap';
import _get from 'lodash/get';
import _pipe from 'lodash/fp/pipe';
import _values from 'lodash/values';

import { createSelector } from 'reselect';
import { linkedAdjustmentKeyBuilder } from '../utilities/linkedAdjustmentsUtilities';
import { LINKED_ADJUSTMENTS_BY_DOCUMENT_KEY } from '../utilities/constants';
import { getFlattenAdjustmentObjectsForDocuments } from './adjustmentSelectors';

export const getLinkedAdjustmentsRoot = (state) =>
  state[LINKED_ADJUSTMENTS_BY_DOCUMENT_KEY];

const getLinkedAdjustmentsNodeForDocumentCode = (documentCode) =>
  createSelector(getLinkedAdjustmentsRoot, (linkedAdjustments) => {
    return _get(linkedAdjustments, documentCode, []);
  });

const buildLinkedAdjustmentAsSourceForDocument = (documentCode) => (la) => {
  const {
    id,
    sourceDocumentCode,
    sourceAdjustmentType,
    sourceAdjustmentName,
    sourceAdjustmentNumber,
    targetDocumentCode,
    targetAdjustmentType,
    targetAdjustmentName,
    targetAdjustmentNumber,
  } = la;

  return {
    id,
    sourceAdjustment:
      documentCode === sourceDocumentCode
        ? linkedAdjustmentKeyBuilder(
            sourceDocumentCode,
            sourceAdjustmentType,
            sourceAdjustmentNumber,
            sourceAdjustmentName
          )
        : linkedAdjustmentKeyBuilder(
            targetDocumentCode,
            targetAdjustmentType,
            targetAdjustmentNumber,
            targetAdjustmentName
          ),
    targetAdjustment:
      documentCode === sourceDocumentCode
        ? linkedAdjustmentKeyBuilder(
            targetDocumentCode,
            targetAdjustmentType,
            targetAdjustmentNumber,
            targetAdjustmentName
          )
        : linkedAdjustmentKeyBuilder(
            sourceDocumentCode,
            sourceAdjustmentType,
            sourceAdjustmentNumber,
            sourceAdjustmentName
          ),
  };
};

export const getLinkedAdjustmentsByCode = (documentCode) =>
  createSelector(
    getLinkedAdjustmentsNodeForDocumentCode(documentCode),
    (linkedAdjustments) => {
      const builder = buildLinkedAdjustmentAsSourceForDocument(documentCode);
      return linkedAdjustments.map(builder);
    }
  );

export const getBrokenAdjustmentLinksForSingleAdjustment = (adjustmentLinks) =>
  createSelector(getFlattenAdjustmentObjectsForDocuments, (allAdjustments) => {
    const missingLinks = [];

    Object.entries(adjustmentLinks).forEach((entry) => {
      const documentCode = entry[0];
      const linkedAdjustments = entry[1];

      linkedAdjustments.forEach((key) => {
        const spaceIndex = key.indexOf(' ');
        const adjustmentNumber = key.substring(0, spaceIndex).trim();
        const adjustmentName = key.substring(spaceIndex).trim();

        const foundAdjustment = _find(allAdjustments, {
          documentCode,
          adjustmentNumber,
          adjustmentName,
        });

        if (!foundAdjustment) {
          missingLinks.push({
            documentCode,
            adjustmentNumber,
            adjustmentName,
          });
        }
      });
    });

    return missingLinks;
  });

// TODO: This will be needed for story 2944
export const getBrokenAdjustmentLinksForAdjustmentGroup = (
  adjustmentGroupLinks
) =>
  createSelector(getFlattenAdjustmentObjectsForDocuments, (allAdjustments) => {
    const links = _pipe(_values, _flatMap)(adjustmentGroupLinks);
    const missingLinks = [];

    links.forEach((val) => {
      const keyParts = val.split('_');
      const documentCode = keyParts[0];
      const adjustmentNumber = keyParts[1];
      const adjustmentName = keyParts[2];

      const foundAdjustment = _find(allAdjustments, {
        documentCode,
        adjustmentNumber,
        adjustmentName,
      });

      if (!foundAdjustment) {
        missingLinks.push({
          documentCode,
          adjustmentNumber,
          adjustmentName,
        });
      }
    });

    return missingLinks;
  });
